import NativePlayerController from './native.player.controller';
import NativePlayerListeners from './native.player.listeners';
import { logDebugging } from '../../../log/logger';

export default class NativePlayerManager {
  constructor(videoData) {
    this.videoData = videoData;
  }

  async load() {
    return new Promise((resolve) => {
      if (this.videoData) {
        // logDebugging('tengo mediaFile');

        this.handler = new NativePlayerListeners(this.videoData);
        this.controller = new NativePlayerController(this.videoData, this.handler);
        resolve(this.controller);
      } else {
        logDebugging('formato de campaña no reconocido, distinto de VPAID o mp4');
        resolve(null);
      }
    });
  }

  getEvent() {
    return this.handler ? this.handler.PlayerEvent : null;
  }
}
